import { render, staticRenderFns } from "./ThemeSettings.vue?vue&type=template&id=0f5658b0&scoped=true"
import script from "./ThemeSettings.vue?vue&type=script&lang=ts"
export * from "./ThemeSettings.vue?vue&type=script&lang=ts"
import style0 from "./ThemeSettings.vue?vue&type=style&index=0&id=0f5658b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5658b0",
  null
  
)

export default component.exports